<section aria-labelledby="network-status-heading">
  <div class="flex bg-gradient-to-r from-[#0b254e] to-[#154fa0] text-white">
    <div class="xl2:px-0 mx-auto w-full max-w-360 gap-2 px-6 py-6">
      <app-analytics-widget class="flex-1">
        <app-ons-widget-summary />
      </app-analytics-widget>
    </div>
  </div>

  <div class="flat-cards border-gray-150 w-full border-b bg-white">
    <div
      class="mx-auto grid w-full max-w-360 grid-cols-2 gap-1 p-1 md:flex md:flex-row md:gap-0 md:divide-x md:divide-gray-300 md:p-0"
      role="list"
      aria-label="Account overview metrics"
    >
      <ng-container *ngxPermissionsOnly="Permission.ORDERS">
        <app-analytics-widget
          class="hover:bg-blue-75 xl2:-ml-6 min-w-0 flex-1 basis-0 px-6 py-1 transition-colors duration-200 ease-in-out md:py-4"
          role="listitem"
        >
          <app-ons-widget-orders [navigateOnClick]="true" />
        </app-analytics-widget>
      </ng-container>

      <ng-container *ngxPermissionsOnly="Permission.SERVICES">
        <app-analytics-widget
          class="hover:bg-blue-75 min-w-0 flex-1 basis-0 px-6 py-1 transition-colors duration-200 ease-in-out md:py-4"
          role="listitem"
        >
          <app-ons-widget-services [navigateOnClick]="true" />
        </app-analytics-widget>
      </ng-container>

      <ng-container *ngxPermissionsOnly="Permission.TICKETING_READ">
        <app-analytics-widget
          class="hover:bg-blue-75 min-w-0 flex-1 basis-0 px-6 py-1 transition-colors duration-200 ease-in-out md:py-4"
          role="listitem"
        >
          <app-ons-widget-tickets [navigateOnClick]="true" />
        </app-analytics-widget>
      </ng-container>
    </div>
  </div>

  <div class="xl2:px-0 mx-auto my-6 min-h-fit w-full max-w-360 gap-2 px-4">
    <div *ngxPermissionsOnly="[Permission.NITEL_IQ_PARTICIPANT]">
      <div class="mb-4 flex flex-col gap-2 sm:flex-row sm:justify-between">
        <h1 id="network-status-heading">Network Status</h1>
        @if (canShowSampleDataToggle()) {
          <div class="flex items-center sm:justify-center">
            <app-toggle
              [ngModel]="(showMockData$ | async) ?? false"
              (ngModelChange)="showMockData$.next($event)"
              [label]="
                (showMockData$ | async)
                  ? 'Switch to Real Data'
                  : 'Switch to Sample Data'
              "
              size="md"
              color="primary"
            >
            </app-toggle>
          </div>
        }
      </div>

      <div
        class="flex flex-col gap-4 transition-all duration-300 ease-in-out lg:h-152 lg:flex-row"
      >
        <div class="flex min-w-0 flex-1 flex-col">
          <div
            class="flex min-h-0 flex-1 flex-col rounded-b-lg bg-[#000A73] shadow-sm"
          >
            <app-analytics-widget class="flex-1">
              <app-maplibre-map
                class="h-full"
                [categories]="categories()"
                [markers]="markers()"
              />
              @if (loading()) {
                <div
                  class="pointer-events-none absolute inset-0 z-0 grid place-items-end"
                >
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
              }
            </app-analytics-widget>

            <div
              class="flex flex-wrap gap-2 rounded-b-lg bg-[#000A73] px-4 py-4 md:gap-6 md:px-6"
              role="list"
              aria-label="Service status legend"
            >
              @if (loading()) {
                <div
                  class="flex animate-pulse gap-6"
                  role="status"
                  aria-label="Loading legend"
                >
                  @for (w of ['w-16', 'w-20', 'w-24', 'w-16']; track $index) {
                    <div class="flex items-center gap-2">
                      <div class="h-6 w-6 rounded-full bg-white/20"></div>
                      <div class="h-3 rounded bg-white/20" [class]="w"></div>
                    </div>
                  }
                </div>
              } @else {
                @for (cat of categories(); track cat.label) {
                  <div class="flex items-center gap-1 md:gap-2" role="listitem">
                    <span
                      class="inline-flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-sm font-bold text-white ring-1 ring-white md:h-6 md:min-w-6 md:px-2"
                      [style.background-color]="getStatusColor(cat.label)"
                      >{{ cat.count || 0 }}</span
                    >
                    <span
                      class="font-montserrat text-xs font-semibold text-white uppercase md:text-sm md:leading-relaxed md:tracking-wide"
                      >{{ cat.label }}</span
                    >
                  </div>
                }
              }
            </div>
          </div>
        </div>
        <div
          class="flex max-h-250 min-h-52 w-full flex-col overflow-hidden md:max-h-none lg:min-h-0 lg:w-90 lg:shrink-0"
        >
          <app-ons-widget-observations
            class="flex flex-1 flex-col overflow-hidden"
            [isLoading]="iqObservationsLoadings()"
            [observations]="observations()"
          />
        </div>
      </div>
    </div>
  </div>
</section>
